import { render, staticRenderFns } from "./ModalNotificacaoEmailDetalhes.vue?vue&type=template&id=7d9fd10c&scoped=true"
import script from "./ModalNotificacaoEmailDetalhes.vue?vue&type=script&lang=ts"
export * from "./ModalNotificacaoEmailDetalhes.vue?vue&type=script&lang=ts"
import style0 from "./ModalNotificacaoEmailDetalhes.vue?vue&type=style&index=0&id=7d9fd10c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9fd10c",
  null
  
)

export default component.exports